<div id="main" class="myw-content d-flex flex-column flex-fill">
    <div class="myw-inner iom-bgclr myw-container">        
      <h1 class="fs-20 text-primary my-4">Upload Tickets</h1>                
      <div class="iom-section">
        <div class="row">
            <div class="col-lg-7 col-12">
          <!-- <h2 class="fs-18 mb-3">Download the ticket template</h2>          
          <div class="iom-download d-flex align-items-center">
              <img src="assets/images/excel.png" alt="Excel" />
              <span>Host_Create_Ticket_Template_Template Name_2020.xlsx</span>    
              <a href="assets/Template/Sample_Template.xlsx" title="Download" class="download-action"><span class="sr-only">Download the ticket template</span></a>
              <div class ='iom-download-status'><strong>Download Success</strong></div>
          </div>
          <hr />
          <div class="d-flex align-items-center text-muted">
              <img src="assets/images/info.svg" alt="info" class="myw-icon myw-24 mr-2" />
              <small>Ticket template must be downloaded before uploading the file</small>
          </div>
          <h2 class="fs-18 my-3">Upload ticket template</h2> -->
          <div class="d-flex flex-row align-items-center justify-content-center iom-upload">
              <small class="d-flex align-items-end justify-content-center"></small>
              <!-- <span class="p-5 text-center title-txt"><span>Note:</span> Upload single file at a time</span> -->
              <label class="iom-file-upload ml-5" id="chooseFile">
                  <span class="btn">Choose a file to upload</span>
                  <input #fileInput type="file" id="file-upload" (click)="fileInput.value = null" accept=".xlsx" (change)="UploadExcelFile($event)"/>
              </label>
              </div>
          </div>
          <div class="col-lg-5 col-12">
            <p class="font-italic text-muted">Note:</p>
            <ul class="iom-noteDet">
                <li>Use ".xlsx" file format to upload the tickets</li>
                <li>Ensure that the 1<sup>st</sup> row contains the ticket header/attribute information</li>
                <li>Some attributes are mandatory – please refer to the <a class="text-primary" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#guidancenotesModal">guidance notes</a> for details.</li>
            </ul>
        </div>
        </div>
          <div class="iom-upload-status d-flex"  id="displayFileName">
              <div class="d-flex align-items-center justify-content-between flex-grow-1">
                  <span id="file-upload-filename"></span>
                  <span id="uploadsuccess"></span>
              </div>
              <a href="javascript:;" class="d-flex align-items-center justify-content-between" title="Delete File" aria-label="Delete File">
                  <img src="assets/images/delete.svg" alt="Delete" class="myw-icon myw-20" (click)=deleteFile(false) />
              </a>
          </div>
          <!-- <div [ngClass]="{'validate-section':'true','d-none':!displayMappingDiv}">
              <div class="row py-4">
                  <div class="col-12 col-lg-4">
                      <div class="form-group mb-0">
                          <label class="form-label myw-required">Select Filter Criteria</label>
                          <select class="form-control" [(ngModel)]="SelectedMapping" (change)="LoadMappingData()">
                              <option>Select</option>
                              <option *ngFor="let filter of categorisedBy">{{filter.Key}}</option>
                          </select>
                      </div>
                  </div>
              </div>
              <div [ngClass]="{'iom-section':true, 'iom-sub-section':true, 'd-none':!displayMappingTable}">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                      <h2 class="fs-18 mb-0">Configure Domain Mapping</h2>
                      <div class="myw-search">
                          <input type="text" (keyup)="searchDomainMapping($event.target.value)" class="form-control control-border" placeholder="{{'Search ' + SelectedMapping}}">
                      </div>
                  </div>
                  <div class="table-responsive">
                      <table class="table table-striped table-fixed">
                          <thead>
                              <tr>
                                  <th scope="col" class="col-6">{{SelectedMapping}}</th>
                                  <th  scope="col" class="text-center col-2">
                                      <label class="myw-checkbox myw-radio myw-inline">
                                          <input type="radio" name="ag-option" (change)="OnDomainChange(null,'AO',true)" [checked]="all_AO" />
                                          <span>AO</span>
                                      </label>
                                  </th>
                                  <th  scope="col" class="text-center col-2">
                                      <label class="myw-checkbox myw-radio myw-inline">
                                          <input type="radio" name="ag-option" (change)="OnDomainChange(null,'IO',true)" [checked]="all_IO"/>
                                          <span>IO</span>
                                      </label>
                                  </th>
                                  <th  scope="col" class="text-center col-2">
                                      <label class="myw-checkbox myw-radio myw-inline">
                                          <input type="radio" name="ag-option" (change)="OnDomainChange(null,'Others',true)" [checked]="all_Others"/>
                                          <span>Others</span>
                                      </label>
                                  </th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let m of MappingFilterData">
                                  <td scope="row" class="col-6">{{m.FieldValue}}</td>
                                  <td class="text-center col-2">
                                      <label class="myw-checkbox myw-radio myw-inline">
                                          <input type="radio" [name]="m.FieldValue" (change)="OnDomainChange(m,'AO',false)" [checked]="m.IsAO" />
                                          <span></span>
                                      </label>
                                  </td>
                                  <td class="text-center col-2">
                                      <label class="myw-checkbox myw-radio myw-inline">
                                          <input type="radio" [name]="m.FieldValue" (change)="OnDomainChange(m,'IO',false)" [checked]="m.IsIO" />
                                          <span></span>
                                      </label>
                                  </td>
                                  <td class="text-center col-2">
                                      <label class="myw-checkbox myw-radio myw-inline">
                                          <input type="radio" [name]="m.FieldValue" (change)="OnDomainChange(m,'Others',false)" [checked]="m.IsOthers" />
                                          <span></span>
                                      </label>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div> -->
          <div class="text-right my-3">
            <button id="btnValidate" class="btn btn-primary" style="width: 10%;" (click)="fileUpload(btnText)">{{btnText}}</button>
            <button type="button"  class="btn btn-secondary" style="width: 10%; margin-left: 20px; margin-right:33px;" (click)="CancelTicketUpload()">Cancel</button>
          </div>
      </div>     
  </div>
</div>

<div class="modal iom-modal-popup" id="guidancenotesModal" tabindex="-1" role="dialog" aria-labelledby="gnTitle" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable iom-modal-pgScroll" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="gnTitle">Guidance Notes</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <p>Please refer to the below table for guidance on the expected attributes that should be included in the data. Kindly ensure to supply the mandatory attributes ensuring that any date/time attributes are provided using the "MM/DD/YYYY HH:MM:SS" format.</p>
                <div class="myw-section mb-4">
                    <div class="table-responsive iom-newtable" style="font-size: 12px;">
                        <table class="table table-striped table-vmiddle myw-table">
                            <thead>
                                <tr>
                                    <th scope="col" width="30%">Expected attributes</th>
                                    <th scope="col">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td width="30%">Ticket Number (Mandatory)</td>
                                    <td>This field helps in identifying a ticket. This field does not accept empty values and it must be unique.</td>
                                </tr>
                                <tr>
                                    <td>Ticket Reported Date (Mandatory)</td>
                                    <td>Date when the ticket is opened and this field does not accept empty values.</td>
                                </tr>
                                <tr>
                                    <td>Ticket Short Description (Mandatory)</td>
                                    <td>Description of the Issue.</td>
                                </tr>
                                <tr>
                                    <td>Assigned Group</td>
                                    <td>Support queue to which the ticket is assigned. This attribute is mandatory for Infra Tickets</td>
                                </tr>
                                <tr>
                                    <td>Tower/Application Name</td>
                                    <td>Application or Service tower to which the ticket has been assigned. Either this attribute or ‘Assigned Group’ should be provided for App. tickets</td>
                                </tr>
                                <tr>
                                    <td>Channel/Source</td>
                                    <td>Channel through which the ticket was reported (Example phone, email, chat etc.) This attribute is mandatory for Infra tickets</td>
                                </tr>
                                <tr>
                                    <td>Ticket Closed Date</td>
                                    <td>Date when the ticket is closed -  used for computing the ticket turn-around-time.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <p>In addition to the critical attributes outlined above, you may also provide additional attributes like the ones shown below including adding your own custom attributes</p>
                <div class="myw-section">
                    <div class="table-responsive iom-newtable"  style="font-size: 12px;">
                        <table class="table table-striped table-vmiddle myw-table">
                            <thead>
                                <tr>
                                    <th scope="col" width="30%">Additional/custom attributes</th>
                                    <th scope="col">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td width="30%">Status</td>
                                    <td>Status of the Ticket.(Open, Closed, On-hold etc.)</td>
                                </tr>
                                <tr>
                                    <td>Priority</td>
                                    <td>This determines the importance of the Ticket/Incident.</td>
                                </tr>
                                <tr>
                                    <td>Resolution SLA</td>
                                    <td>If the ticket has met/failed Resolution SLA.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
